import { render, staticRenderFns } from "./InfoVacationPackageTheme1.vue?vue&type=template&id=04570168&scoped=true"
import script from "./InfoVacationPackageTheme1.vue?vue&type=script&lang=js"
export * from "./InfoVacationPackageTheme1.vue?vue&type=script&lang=js"
import style0 from "./InfoVacationPackageTheme1.vue?vue&type=style&index=0&id=04570168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04570168",
  null
  
)

export default component.exports